import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Preloader from "../../assets/sab.jpeg";
import {
  fetchTrainingsData,
  fetchTrainingDocs,
} from "../../redux/slicer/researchAndStudentSlice";
import Slider from "react-slick";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import AcedamicsImg from "../../assets/Banners/Academics.jpg";
import { FaFilePdf, FaFileExcel } from "react-icons/fa"; // Import icons

function TrainingPatners() {
  const dispatch = useDispatch();
  const {
    data: images,
    loading,
    error,
  } = useSelector((state) => state.research.trainings);

  const {
    data: docs,
    docsLoading,
    docsError,
  } = useSelector((state) => state.research.docs);

  useEffect(() => {
    dispatch(fetchTrainingsData());
    dispatch(fetchTrainingDocs());
  }, [dispatch]);

  if (loading || docsLoading) {
    return <div>Loading...</div>;
  }

  if (error || docsError) {
    return (
      <div>
        Error: {error || docsError}
      </div>
    );
  }

  const slidesToShow = Math.min(
    Array.isArray(images) ? images.length : 0,
    5
  ); // Ensure images is an array before accessing length

  const settings = {
    dots: true,
    infinite: Array.isArray(images) && images.length > 1, // Disable infinite loop if only one image
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    arrows: Array.isArray(images) && images.length > 1,
    prevArrow:
      Array.isArray(images) && images.length > 1 ? (
        <div className="absolute top-1/2 left-0 transform -translate-y-1/2 bg-white p-2 rounded-full cursor-pointer z-10">
          <FaChevronLeft className="text-primary-color text-lg" />
        </div>
      ) : null,
    nextArrow:
      Array.isArray(images) && images.length > 1 ? (
        <div className="absolute top-1/2 right-0 transform -translate-y-1/2 bg-white p-2 rounded-full cursor-pointer z-10">
          <FaChevronRight className="text-primary-color text-lg" />
        </div>
      ) : null,
    responsive: [
      {
        breakpoint: 1536,
        settings: {
          slidesToShow: Math.min(Array.isArray(images) ? images.length : 0, 4),
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: Math.min(Array.isArray(images) ? images.length : 0, 3),
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: Math.min(Array.isArray(images) ? images.length : 0, 3),
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
    ],
  };

  const getFileIcon = (file_url) => {
    if (file_url.endsWith(".pdf")) {
      return <FaFilePdf className="text-red-500 text-2xl" />;
    } else if (file_url.endsWith(".xlsx") || file_url.endsWith(".xls")) {
      return <FaFileExcel className="text-green-500 text-2xl" />;
    } else {
      return <FaFilePdf className="text-primary-color text-2xl" />; // Default icon
    }
  };

  const hasImages = Array.isArray(images) && images.length > 0;
  const hasDocs = Array.isArray(docs) && docs.length > 0;

  return (
    <div className="bg-gray-100 min-h-screen">
      {/* Banner Section */}
      <div className="relative max-w-full mx-auto">
        <div className="contain overflow-hidden w-full  h-[400px]">
          <img
            src={AcedamicsImg} // Use the imported image
            alt="Program Details Banner"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute top-1/3 left-1/2 transform -translate-x-1/2 text-center text-white">
            <h2 className="text-4xl md:text-5xl  font-bold  font-titillium ">
             
            </h2>
            <p className="text-lg mt-10 bg-img-description  font-titillium"></p>
          </div>
        </div>
      </div>

      {/* Documents Section */}
      {hasDocs && (
        <div className="container mx-auto py-8 px-4 sm:px-6 lg:px-8">
          <div className="bg-white shadow overflow-hidden rounded-md">
            <div className="p-6">
              <h3 className="text-2xl font-semibold text-gray-800 mb-4">
                Training Documents
              </h3>
              <ul className="list-disc pl-5">
                {docs.map((doc) => (
                  <li key={doc.id} className="mb-2">
                    <a
                      href={doc.file_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-primary-color hover:text-blue-700 flex items-center"
                    >
                      {getFileIcon(doc.file_url)}
                      <span className="ml-2">
                        {doc.file_path.split("-").pop()}
                      </span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      )}

      {/* Program Details Section */}
      {hasImages && (
        <div className="container mx-auto py-8 px-4 sm:px-6 lg:px-8">
          <div className="bg-white shadow overflow-hidden rounded-md">
            <div className="p-6">
              {/* Program Description */}
              <div className="relative w-full max-w-5xl mx-auto">
                <h3 className="text-2xl font-semibold text-gray-800 mb-4">
                  Our Training Partners
                </h3>
                <Slider {...settings}>
                  {images.map((image, index) => (
                    <div
                      key={index}
                      className="flex flex-col items-center justify-center bg-white"
                    >
                      {/* Image with onClick handler */}
                      <img
                        src={image.image_url}
                        className="w-[176px] h-[53px] sm:h-[200px] object-scale-down cursor-pointer mx-auto"
                        alt={`Slide ${index + 1}`}
                        onClick={() => window.open(image.url, "_blank")}
                      />

                      <h2 className="text-xl font-bold text-primary-color mt-4">
                        {image.partner_name}
                      </h2>
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          </div>
        </div>
      )}

      {!hasImages && hasDocs && (
        <div className="container mx-auto py-8 px-4 sm:px-6 lg:px-8">
          <div className="bg-white shadow overflow-hidden rounded-md">
            <div className="p-6">
              <p>No training partners available,:</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default TrainingPatners;